///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>
///<reference path="report-employees.collection.ts"/>


module Meevo.Components.Controls.SmartMover {
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import IReportEmployee = Meevo.Plugins.Reports.IReportEmployee;

    export class ReportPayrollEmployeesCollection extends ReportEmployeesCollection implements IApiCollection<IReportEmployee> {

        protected get url() {
            return 'Report/PayrollEmployee';
        }

        protected get smartMoverHiddenValue() {
            return SmartMoverHiddenValue.Ids;
        }

        constructor(connectedModel: ModelValueType[], items: IReportEmployee[] = [], options: ICollectionOptions<IReportEmployee> = {}) {
            super(connectedModel, items, options);

            this.updateCriteria({
                objectStateEnumList_TBL: [ObjectStateEnum.Active, ObjectStateEnum.Inactive, ObjectStateEnum.Deleted]
            });
        }

        protected criteriaIsValid(): boolean {
            if (!this.criteria['objectStateEnumList_TBL'] || !this.criteria['PayrollPeriodList_TBL']) return false;

            return super.criteriaIsValid();
        }
    }

}
